import { useState } from "react";
import {  useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Nav.css";
import closeIcon from '../assets/closeIcon.png'
import menuIcon from '../assets/menuIcon.png'
import logo from '../assets/akari-logo.png'



function Nav() {

  const [isMenuOpen, setMenuOpen] = useState(false)

  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();


  const toggleMenu = () =>{
    setMenuOpen(!isMenuOpen)
  }
  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return(
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
       <img src={logo} alt="JLL Leader" width="90" />
        </div> 

        <div className="navbar-icon" onClick={toggleMenu}>
          <img src={isMenuOpen ? closeIcon : menuIcon} alt="" />
        </div>

        <div  className={`navbar-menu ${isMenuOpen ? "Open" : ""}`}>
          <ul className="navbar-menuItems">
            <li>
            <a href='/'>الصفحة الرئيسية</a>
            </li>
            <li>
            <a href='/about'>نبذة عن</a>
            </li>
           {/* <li>
            <a href='/news'>الأخبار</a>
            </li> */}
            
            <li>
            <a href='/propertylist'>العقارات</a>
            </li>
            <li>
           
            <div
          className="dropdown"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
          
        >
        
        <a href='/'>خدمات</a>
          <div className={`dropdown-content ${dropdownOpen ? "show" : ""}`}>
            <a href="realestatemarketing">تسويق العقارات</a>
            <a href="realestatebrokerage">الوساطة العقارية</a>
            <a href="realestatevaluation">التثمين العقاري</a>
            <a href="realestateauctions">مزادات العقارات</a>
            <a href="#">تقييم العقارات</a>
            <a href="realestateconsulting">خدمات الاستشارات العقارية</a>
            <a href="contractdocumentation">معالجة عقود البيع والشراء وعقود الإيجار</a>
             <a href="facilitymanagement">إدارة المرافق</a>
            <a href="#">مشاريع عقارية قيد الإنشاء</a>
          </div>
        </div>
            </li>
            <li>
            <a href='/blog'>مدونة</a>
            </li>
            <li>
            <a href='/contact'>اتصل بنا</a>
            </li>
          </ul>
          <p className="navbar-submit">
            {user ? (
              <button onClick={handleLogout}>تسجيل الخروج</button>
            ) : (
              <a href="/login">تسجيل الدخول</a>
            )}
          </p>
        </div> 
      </div>
    </nav> 
  )
} 

export default Nav





 
